import { useCallback } from 'react';
import useIgnoreRenderEffect from './useIgnoreRenderEffect';

//Execute the first effect and use a callback
const useAsyncEffect = (func: () => void, deps: any[]) => {
    const callBack = useCallback(func, deps);

    useIgnoreRenderEffect(() => {
        callBack();
    }, [callBack]);
};

export default useAsyncEffect;
